import { salesApiInstance } from "./client.js";

export const visitsApi = {
    getAll: async (params = {}) => {
        return salesApiInstance.get("/visits", { params });
    },
    getById: async (id) => {
        return salesApiInstance.get(`/visits/${id}`);
    },
    create: async (data) => {
        return salesApiInstance.post("/visits", data);
    },
    update: async (id, data) => {
        return salesApiInstance.put(`/visits/${id}`, data);
    },
    delete: async (id) => {
        return salesApiInstance.delete(`/visits/${id}`);
    },
    planRoute: async (data) => {
        return salesApiInstance.post("/visits/plan-route", data);
    },
    bulkDelete: async (ids) => {
        return salesApiInstance
            .post("/visits/bulk-delete", { ids })
            .then((r) => r.data);
    },
    // Visit log endpoints
    logVisit: async (id, data) => {
        return salesApiInstance.post(`/visits/${id}/log`, data);
    },
    getLogs: async (id, params = {}) => {
        return salesApiInstance.get(`/visits/${id}/logs`, { params });
    },
    // Admin queue management
    adminQueueSummary: async (date) => {
        return salesApiInstance.get("/visits/admin/queue-summary", {
            params: date ? { date } : {},
        });
    },
    adminRunPopulate: async () => {
        return salesApiInstance.post("/visits/admin/run-populate");
    },
    adminReassign: async (from_sales_id, to_sales_id, date) => {
        return salesApiInstance.post("/visits/admin/reassign", {
            from_sales_id,
            to_sales_id,
            date,
        });
    },
    adminAllLogs: async (params = {}) => {
        return salesApiInstance.get("/visits/admin/all-logs", { params });
    },
    // System settings
    getSystemSettings: async () => {
        return salesApiInstance.get("/admin/system-settings");
    },
    updateSystemSetting: async (key, value) => {
        return salesApiInstance.put(`/admin/system-settings/${key}`, { value });
    },
};
